import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import './WorkbookStyle.css';
import { Container, Col, Row, Card, Accordion } from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-modal'
import axios from 'axios';
import moment from 'moment';

import firebase from 'lib/firebase';
import api from 'lib/api';
import global from 'lib/global';
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

import * as UserActions from 'store/modules/UserModule';

class HeaderWrite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInfo: '',

            // 신청모달
            visibleModal: false,
            visibleAlert: false,
            alert: '',

            sendLevel: 0,
            sendName: "",
            sendEmail: "",
            sendText: "",

        }
    }

    componentDidMount() {
        const self = this;

        firebase.auth().onAuthStateChanged(async function (user) {
            let userData = await self.props.userActions.getUserInfo();
            if (userData.data.result) {
                self.setState({ userInfo: userData.data.data });
            }
        });
    }

    // 신청 모달
    onClickApply = () => {
        this.setState({ visibleModal: !this.state.visibleModal });
    }

    changeLevel = (e) => {
        console.log("choosed level")
        this.setState({ sendLevel: e.target.value });
    }

    changeName = (e) => {
        console.log("input name")

        let name = e.target.value;
        var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi; //특수문자 제거
        name = name.replace(regExp, "");

        this.setState({ sendName: name });
    }

    changeEmail = (e) => {
        console.log("input email")
        this.setState({ sendEmail: e.target.value });
    }

    changeText = (e) => {
        console.log("input text")
        this.setState({ sendText: e.target.value });
    }

    onClickSubmit = () => {
        const self = this;

        if (this.state.sendLevel == 0) {
            //추가 - 레벨을 선택해주세요
            this.setState({
                alert: "Choose the difficulty of the worksheets.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        if (!this.state.sendName || this.state.sendName.length < 3) {
            //추가 - 닉네임을 입력해 주세요
            this.setState({
                alert: "Please write your nickname 'more than 3 words'.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.state.sendEmail || !re.test(this.state.sendEmail)) {
            //추가 - 이메일 형식이 잘못되었습니다
            this.setState({
                alert: "Please fill in the blank with your email address, following the form given.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        if (this.state.sendText.length > 500) {
            this.setState({
                alert: "Please write under 500 letters.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        let item = {
            name: this.state.sendName,
            email: this.state.sendEmail,
            level: this.state.sendLevel,
            memo: this.state.sendText,
        }

        api.post('/workbook/users/joinAdd', { item: item })
            .then(function (response) {
                if (response.data.result) {
                    //추가 - 등록이 완료되었습니다
                    self.setState({
                        alert: "Your registration has been completed successfully.",
                        visibleModal: !self.state.visibleModal,
                        visibleAlert: !self.state.visibleAlert
                    })
                } else {
                    //추가 - 등록이 실패 하였습니다
                    self.setState({
                        alert: "Your email has already been registered.",
                        visibleAlert: !self.state.visibleAlert
                    })
                }
            })
            .catch(function (err) {
                //추가 - 등록이 실패 하였습니다
                self.setState({
                    alert: "The registration has failed.",
                    visibleAlert: !self.state.visibleAlert
                })
            })
    }


    render() {
        // console.log("user111?", this.props.userInfo)
        let userProfile = '/profile_empty.png'
        if (this.props.userInfo.photo && this.props.userInfo.photo.length > 0) {
            userProfile = this.props.userInfo.photo;
        }

        let LayoutApplyInputName = (
            <input type="text" placeholder="Name" onChange={this.changeName} value={this.state.sendName}></input>
        )
        let LayoutApplyInputEmail = (
            <input type="email" placeholder="Email address" onChange={this.changeEmail}></input>
        )
        if (this.props.userInfo.idx) {
            LayoutApplyInputName = (
                <input type="text" placeholder="Name" onChange={this.changeName} value={this.state.userInfo.nick_name} disabled></input>
            );

            LayoutApplyInputEmail = (
                <input type="email" placeholder="Email address" onChange={this.changeEmail} value={this.state.userInfo.email} disabled></input>
            );
        }


        return (
            <div id="write_ad">
                <div id="header">
                    <div className="inner_header">
                        <Container>
                            <Row>
                                <Col xs={12} sm={12} md={4} lg={4} className="logoSpace">
                                    <HashLink onClick={() => this.setState({ screen_layout: 0 })} to="/workbook#top">
                                        <img src={"/write/ad_logo.png"} alt="boomco logo" className="header_logo" />
                                    </HashLink>
                                </Col>
                                <Col xs={12} sm={12} md={8} lg={8} style={{ margin: 0, padding: 0 }}>
                                    <Container>
                                        <Row>
                                            <Col xs={2} className="gnb">
                                                <HashLink to={"/#top"}>Home</HashLink>
                                            </Col>
                                            <Col xs={3} className="gnb">
                                                <HashLink to={"/#howitworks"}>How it works</HashLink>
                                            </Col>
                                            <Col xs={3} className="gnb">
                                                <HashLink to={"/#subscribe"}>Subscribe</HashLink>
                                            </Col>
                                            <Col xs={3} className="gnb">
                                                <a className="apply_header" onClick={this.onClickApply}>Apply now</a>
                                            </Col>
                                            <Col xs={1} className="gnb">
                                                <Link to="/mypage">
                                                    <img src={userProfile} alt="profile" style={{ width: 30, height: 30, borderRadius: 50 }} />
                                                </Link>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>

                {/* modal(신청입력) */}
                <Modal
                    isOpen={this.state.visibleModal}
                    onRequestClose={() => this.setState({ visibleModal: false })}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <h3>Register now {'\u0026'}<br />Receive <strong>ONE FREE</strong> worksheets</h3>
                    <select onChange={this.changeLevel} >
                        <option value={0} disabled selected hidden>Choose the level of worksheets</option>
                        <option value={1}>Beginner</option>
                        <option value={2}>Intermediate - Advanced</option>
                    </select>
                    {LayoutApplyInputName}
                    {LayoutApplyInputEmail}
                    <textarea type="textarea" placeholder="Other (You may leave it empty)" className="textArea" onChange={this.changeText}></textarea>
                    <p className="warning">{'\u203B'}{'\u00A0'}If you can not find your email in your normal mailbox, please check in your spam or junk mail sections. And if you find our email there, select the confirmation message and click “not junk”.</p>
                    {/* <p style={{ color: '#666', fontSize: 15, letterSpacing: -0.5 }}><strong style={{ color: '#E51414', fontSize: 17 }}>{'\u203B'}{'\u00A0'}Holiday Notice</strong><br />We will be closed from 10th Feb 2021 - 15th Feb 2021. We are back on 16th Feb 2021.</p> */}
                    <div className="submit" onClick={this.onClickSubmit}>Apply now</div>
                </Modal>


                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Col className="my-auto" style={{ textAlign: "center", color: "#9b9daa", fontSize: 18, padding: 0 }}>{this.state.alert}</Col>
                        <Col className="alertClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</Col>
                    </Container>
                </Modal>
            </div>
        )
    }
}




let mapStateToProps = (state) => ({
    userInfo: JSON.parse(JSON.stringify(state.UserModule.get('userInfo'))),
});

let mapDispatchToProps = (dispatch) => ({
    userActions: bindActionCreators(UserActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrite);